import FileSaver from 'file-saver'
import { I18n } from 'lib/i18n'
import { get, post, put } from 'lib/utilities'
import { toast } from 'react-toastify'

const LOAD = 'contactRequests/LOAD_USERS'
const LOAD_DONE = 'contactRequests/LOAD_USERS_DONE'
const LOAD_FAILED = 'contactRequests/LOAD_USERS_DONE'
const LOAD_CSV = 'contactRequests/LOAD_CSV'
const LOAD_CSV_DONE = 'contactRequests/LOAD_CSV_DONE'
const LOAD_CSV_FAILED = 'contactRequests/LOAD_CSV_FAILED'
const CREATE = 'contactRequests/CREATE'
const CREATE_DONE = 'contactRequests/CREATE_DONE'
const CREATE_FAILED = 'contactRequests/CREATE_FAILED'
const SELECT = 'contactRequests/SELECT'
const SELECT_DONE = 'contactRequests/SELECT_DONE'
const SELECT_FAILED = 'contactRequests/SELECT_FAILED'

export const loadContactRequests = () => ({ type: LOAD })
export const loadContactRequestsFulfilled = (contactRequests) => ({
  type: LOAD_DONE,
  contactRequests,
})
export const loadContactRequestsFailed = (errors) => ({
  type: LOAD_FAILED,
  errors,
})
export const loadContactRequestsCSV = () => ({ type: LOAD_CSV })
export const loadContactRequestsCSVFulfilled = () => ({ type: LOAD_CSV_DONE })
export const loadContactRequestsCSVFailed = (errors) => ({
  type: LOAD_CSV_FAILED,
  errors,
})
export const createContactRequest = (values) => ({ type: CREATE, values })
export const createContactRequestFulfilled = () => ({ type: CREATE_DONE })
export const createContactRequestFailed = (errors) => ({
  type: CREATE_FAILED,
  errors,
})
export const selectContactRequest = (id) => ({ type: SELECT, id })
export const selectContactRequestFulfilled = (id) => ({ type: SELECT_DONE, id })
export const selectContactRequestFailed = (errors) => ({
  type: SELECT_FAILED,
  errors,
})

const initialState = {
  contactRequests: [],
  contactRequestsLoading: false,
  selectedContactRequestId: 0,
}

export const contactRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, contactRequestsLoading: true }
    case LOAD_DONE:
      return {
        ...state,
        contactRequestsLoading: false,
        contactRequests: action.contactRequests,
      }
    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/contact_requests.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadContactRequestsFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.contactRequests/LOAD_USERS_FAILED'))
        return [loadContactRequestsFailed(result.body.errors)]
      }
    })

export const loadCSVEpic = (action$, store) =>
  action$
    .ofType(LOAD_CSV)
    .mergeMap((action) => get('/contact_requests.csv'))
    .mergeMap((result) => {
      if (result.ok) {
        const file = new File(
          [result.text],
          `contact_requests_${new Date().toISOString()}.csv`,
          { type: 'application/csv;charset=utf-8' }
        )
        FileSaver.saveAs(file)
        return [loadContactRequestsCSVFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.contactRequests/LOAD_USERS_FAILED'))
        return [loadContactRequestsCSVFailed(result.body.errors)]
      }
    })

export const selectEpic = (action$, store) =>
  action$
    .ofType(SELECT)
    .filter((action) => action.id > 0)
    .mergeMap((action) =>
      put('/contact_requests/' + action.id, { contact_request: { read: true } })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [selectContactRequestFulfilled(), loadContactRequests()]
      } else {
        toast.error(I18n.t('action.contactRequests/SELECT_FAILED'))
        return [selectContactRequestFailed(result.body.errors)]
      }
    })

export const createEpic = (action$, store) =>
  action$
    .ofType(CREATE)
    .mergeMap((action) => post('/contact_requests.json', action.values))
    .mergeMap((result) => {
      if (result.ok) {
        return [
          //TODO: Message and jump to start page
          createContactRequestFulfilled(),
        ]
      } else {
        toast.error(I18n.t('action.contactRequests/CREATE_FAILED'))
        return [createContactRequestFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/contactRequests.js